import React, { useEffect, useRef, useState } from "react";
import {
  FaBars,
  FaChevronDown,
  FaEnvelope,
  FaSignOutAlt,
  FaUser,
  FaUserCircle,
} from "react-icons/fa";
import { Link } from "react-router-dom";

export default function Header({ userType, setIsSidebarOpen, onLogout }) {
  const [showMessages, setShowMessages] = useState(false);
  const [showAccountMenu, setShowAccountMenu] = useState(false);

  const messageRef = useRef(null);
  const accountRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        messageRef.current &&
        !messageRef.current.contains(event.target)
      ) {
        setShowMessages(false);
      }

      if (
        accountRef.current &&
        !accountRef.current.contains(event.target)
      ) {
        setShowAccountMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleAccountToggle = () => {
    setShowAccountMenu((prev) => !prev);
    setShowMessages(false);
  };

  const handleMessagesToggle = () => {
    setShowMessages((prev) => !prev);
    setShowAccountMenu(false);
  };

  const handleLogout = () => {
    setShowAccountMenu(false);
    onLogout?.();
  };

  return (
    <header
      dir="rtl"
      className="
        sticky top-0 z-[101]
        w-full
        border-b border-gray-100
        bg-white
        shadow-sm
        md:static md:border-none md:bg-transparent md:shadow-none
      "
    >
      <div className="container mx-auto px-4 py-3 md:px-6 md:py-4">
        <div
          className="
            flex min-h-[64px] items-center justify-between
            gap-3
            rounded-2xl
            bg-white
            md:border md:border-gray-200 md:px-4 md:shadow-sm
          "
        >
          {/* سمت راست: منو و لوگو */}
          <div className="flex min-w-0 items-center gap-2 md:gap-4">
            <button
              type="button"
              aria-label={
                "باز و بسته کردن منوی حساب کاربری"
              }
              onClick={() => setIsSidebarOpen((prev) => !prev)}
              className="
                flex h-11 w-11 shrink-0 items-center justify-center
                rounded-lg
                border border-gray-200
                bg-white
                text-[#1E3A5F]
                transition-colors duration-200
                hover:border-[#1E3A5F]
                hover:bg-gray-50
                focus:outline-none
                focus:ring-2
                focus:ring-[#1E3A5F]/20
              "
            >
              <FaBars className="text-lg md:text-xl" />
            </button>

            <Link
              to="/"
              aria-label="صفحه اصلی"
              className="flex shrink-0 items-center"
            >
              <img
                src="/images/logo.png"
                alt="Sazin"
                className="
                  h-9 w-9
                  rounded-lg
                  object-contain
                  md:h-11 md:w-11
                "
              />
            </Link>

            {/* عنوان پنل فقط در دسکتاپ */}
            <div className="hidden min-w-0 md:block">
              <p className="truncate text-sm font-semibold text-gray-800">
                حساب کاربری
              </p>
            </div>
          </div>

          {/* سمت چپ: پیام‌ها و حساب کاربری */}
          <div className="flex shrink-0 items-center gap-2 md:gap-3">
            {/* پیام‌ها */}
            <div className="relative" ref={messageRef}>
              <button
                type="button"
                aria-label="پیام‌ها"
                aria-expanded={showMessages}
                onClick={handleMessagesToggle}
                className="
                  relative
                  flex h-11 w-11 items-center justify-center
                  rounded-lg
                  border border-gray-200
                  bg-white
                  text-[#1E3A5F]
                  transition-colors duration-200
                  hover:border-[#1E3A5F]
                  hover:bg-gray-50
                  focus:outline-none
                  focus:ring-2
                  focus:ring-[#1E3A5F]/20
                "
              >
                <FaEnvelope className="text-lg" />

                <span
                  className="
                    absolute -right-1 -top-1
                    flex h-5 min-w-5 items-center justify-center
                    rounded-full
                    bg-[#E74C3C]
                    px-1
                    text-[10px]
                    font-medium
                    text-white
                  "
                >
                  ۳
                </span>
              </button>

              {showMessages && (
                <div
                  className="
                    absolute left-0 top-full z-[110]
                    mt-2
                    w-64
                    rounded-xl
                    border border-gray-200
                    bg-white
                    p-4
                    text-gray-700
                    shadow-lg
                  "
                >
                  <h3 className="mb-2 border-b border-gray-100 pb-2 text-sm font-semibold text-gray-800">
                    پیام‌های اخیر
                  </h3>

                  <p className="mb-3 text-xs text-gray-500">
                    شما ۳ پیام خوانده‌نشده دارید.
                  </p>

                  <Link
                    to="/messages"
                    onClick={() => setShowMessages(false)}
                    className="
                      text-xs font-medium
                      text-[#1E3A5F]
                      hover:text-[#2B5388]
                      hover:underline
                    "
                  >
                    مشاهده همه پیام‌ها
                  </Link>
                </div>
              )}
            </div>

            {/* حساب کاربری */}
            <div className="relative" ref={accountRef}>
              <button
                type="button"
                aria-label="منوی حساب کاربری"
                aria-expanded={showAccountMenu}
                onClick={handleAccountToggle}
                className="
                  flex h-11 items-center gap-2
                  rounded-lg
                  bg-[#1E3A5F]
                  px-3
                  text-[#FFC107]
                  transition-colors duration-200
                  hover:bg-[#2B5388]
                  focus:outline-none
                  focus:ring-2
                  focus:ring-[#1E3A5F]/30
                  md:px-4
                "
              >
                <FaUser className="text-base md:text-lg" />

                <span className="hidden text-sm font-medium sm:inline">
                  حساب کاربری
                </span>

                <FaChevronDown
                  className={`
                    text-[10px]
                    transition-transform duration-200
                    ${showAccountMenu ? "rotate-180" : ""}
                  `}
                />
              </button>

              {showAccountMenu && (
                <div
                  className="
                    absolute left-0 top-full z-[110]
                    mt-2
                    w-48
                    overflow-hidden
                    rounded-xl
                    border border-gray-200
                    bg-white
                    py-1
                    text-gray-700
                    shadow-lg
                  "
                >
                  <Link
                    to={`/${userType}-panel/`}
                    onClick={() => setShowAccountMenu(false)}
                    className="
                      flex items-center gap-3
                      border-b border-gray-100
                      px-4 py-3
                      text-sm
                      transition-colors
                      hover:bg-gray-50
                      hover:text-[#1E3A5F]
                    "
                  >
                    <FaUserCircle className="text-gray-400" />
                    <span>حساب کاربری</span>
                  </Link>

                  <button
                    type="button"
                    onClick={handleLogout}
                    className="
                      flex w-full items-center gap-3
                      px-4 py-3
                      text-right
                      text-sm
                      text-[#E74C3C]
                      transition-colors
                      hover:bg-red-50
                    "
                  >
                    <FaSignOutAlt />
                    <span>خروج از حساب</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
